import React from "react";
import { useNavigate } from "react-router-dom";

const BanquetNavbar = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/');
    // Esperar a que la página se cargue y luego hacer scroll
    setTimeout(() => {
      const detailsSection = document.getElementById('details');
      if (detailsSection) {
        detailsSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <nav className="bg-gradient-to-br from-castle-cream-300 to-royal-gold-200 shadow-md p-2 fixed w-full top-0 z-40">
      <div className="container mx-auto flex justify-between items-center">
        <button
          onClick={handleBack}
          className="flex items-center space-x-2 text-beast-brown-600 hover:text-royal-gold-800 active:scale-95 transition-all duration-300"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
          <span>Atrás</span>
        </button>
        
        <span className="font-cursive font-extrabold text-xl text-royal-gold-700">B@B</span>
      </div>
    </nav>
  );
};

export default BanquetNavbar;
